import { useEffect, useMemo, useState } from 'react';

import { default as Table, type TableProps } from 'antd/es/table';
import { generateFilters } from '../utils/antd/tableFilter';

interface DataType {
  key: string;
  kind: string;
  group: string;
  reason: string;
  external_message: string;
  symbol: string;
}

export function ReasonCodesCollection({ filePath }: { filePath: string }) {
  const [data, setData] = useState<DataType[]>([]);

  useEffect(() => {
    import(`../data/${filePath}.json`).then((data) => setData(data.default));
  }, [filePath]);

  const columns: TableProps<DataType>['columns'] = useMemo(
    () => [
      {
        title: 'Kind',
        dataIndex: 'kind',
        key: 'kind',
        render: (kind) => <code>{kind}</code>,
        ...generateFilters(data, 'kind')
      },
      {
        title: 'Group',
        dataIndex: 'group',
        key: 'group',
        render: (group) => <code>{group}</code>,
        ...generateFilters(data, 'group')
      },
      {
        title: 'Reason',
        dataIndex: 'reason',
        key: 'reason'
      },
      {
        title: 'External Message',
        dataIndex: 'external_message',
        key: 'external_message'
      },
      {
        title: 'Symbol',
        dataIndex: 'symbol',
        key: 'symbol',
        render: (code) => <code>{code}</code>,
        ...generateFilters(data, 'symbol')
      }
    ],
    [data]
  );

  return (
    <Table
      columns={columns}
      dataSource={data}
      size="small"
      pagination={{ pageSize: 20 }}
    />
  );
}
